import { inject, Injectable } from '@angular/core';
import { SnackbarService, SnackbarType } from '@fuse/services/snackbar';

import { HttpClientService } from '../data/http-client.service';

@Injectable({ providedIn: 'root' })
export abstract class BaseService {
  protected readonly clientService = inject(HttpClientService);
  protected readonly snackbarService = inject(SnackbarService);

  protected showMessage(type: SnackbarType, message: string) {
    this.snackbarService.open(message, type);
  }
}
